import { render, staticRenderFns } from "./ClipBox.vue?vue&type=template&id=071ac2c4&"
import script from "./ClipBox.vue?vue&type=script&lang=js&"
export * from "./ClipBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports